<template>
  <div id="BottomNAV">
  <mu-container>
<!-- replace -->
    <mu-bottom-nav :value="bottomNav">
<!--   <mu-bottom-nav-item title="Assets" value="Home" icon=" " class="nav0"></mu-bottom-nav-item>
    <mu-bottom-nav-item title="Transaction" value="Transaction" icon=" " class="nav1"></mu-bottom-nav-item> -->
  <mu-bottom-nav-item title="Assets" value="Home" icon=" " class="nav0" to="/M/Home"></mu-bottom-nav-item>
    <mu-bottom-nav-item title="Transaction" value="Transaction" icon=" " class="nav1" to="/M/Transaction"></mu-bottom-nav-item>
    <mu-bottom-nav-item title="OTC" value="OTC" icon=" " class="nav2" to="/M/OTC"></mu-bottom-nav-item>
    <mu-bottom-nav-item title="Personal" value="Personal" icon=" " class="nav3" to="/M/Personal"></mu-bottom-nav-item>
    </mu-bottom-nav>

  </mu-container>
  </div>
</template>

<script>
  export default {
      data() {
    const pa=this.$route.path;
    const Pa=pa.slice(1);

    return{
      bottomNav: Pa
    }
      },
      mounted() {
        // console.log(":::"+this.$route.path)
        // this.fetchData()
        // this.bottomNav = sessionStorage.getItem('navItem')
      },
    // watch: {
    // "$route":"changebar"
    // },
      methods: {
    handleChange (val) {
      console.log(":"+val+":"+val);
      this.bottomNav = val
    }
    // changebar(){
    //   const va=this.$route.path;
    //   const Va=va.slice(1);
    //   console.log(":"+va+":"+Va);
    //   this.bottomNav = Va
    // }
        //  fetchData () {
        //     if (this.$route.path === "/Home") {
        //         this.bottomNav = "Home"
        //     }
        //     if (this.$route.path === "/Transaction") {
        //         this.bottonNav = "Transaction"
        //     }
        //     if (this.$route.path === "/books") {
        //         this.bottomNav = "books"
        //     }
        //     if (this.$route.path === "/pictures") {
        //         this.bottomNav = "pictures"
        //     }
        // }

    // handleChange (val) {
    //   console.log(":::"+val);
    //   // this.$router.push(var);
    //     // this.bottomNav = val // 这里的val输出是导航栏的下标
    //     // // 使用任何一种存储状态的方法，vuex也好，我这里使用sessionStorage
    //     // sessionStorage.setItem('navItem', this.bottomNav) //存储状态
    // }
      },
    components: {
    }
    };
</script>

<style>
  /* 非选中态图标 */
  #BottomNAV .nav0 .mu-bottom-item-icon {
    background-image: url(../assets/image/btn_1_0.png);
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
    background-size: auto 24px;
  }

  #BottomNAV .nav1 .mu-bottom-item-icon {
    background-image: url(../assets/image/btn_2_0.png);
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
    background-size: auto 24px;
  }

  #BottomNAV .nav2 .mu-bottom-item-icon {
    background-image: url(../assets/image/btn_3_0.png);
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
    background-size: auto 24px;
  }

  #BottomNAV .nav3 .mu-bottom-item-icon {
    background-image: url(../assets/image/btn_4_0.png);
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
    background-size: auto 24px;
  }

  /* 选中态图标 */
  #BottomNAV .nav0.router-link-exact-active.router-link-active .mu-bottom-item-icon {
    background-image: url(../assets/image/btn_1_1.png);
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
    background-size: auto 24px;
  }

  #BottomNAV .nav1.router-link-exact-active.router-link-active .mu-bottom-item-icon {
    background-image: url(../assets/image/btn_2_1.png);
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
    background-size: auto 24px;
  }

  #BottomNAV .nav2.router-link-exact-active.router-link-active .mu-bottom-item-icon {
    background-image: url(../assets/image/btn_3_1.png);
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
    background-size: auto 24px;
  }

  #BottomNAV .nav3.router-link-exact-active.router-link-active .mu-bottom-item-icon {
    background-image: url(../assets/image/btn_4_1.png);
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
    background-size: auto 24px;
  }

  //字体颜色
  #BottomNAV .mu-bottom-item-text {
    color: #999999
  }

  #BottomNAV .router-link-exact-active.router-link-active .mu-bottom-item-text {
    color: #2b2b2b;
  }
</style>



// WEBPACK FOOTER //
// src/OK_Scott/components/Bottom-nav.vue